export default {
  "language": "fr",
  "message":
    {
      "title": "Calculateur de bonus au logement à revenus mixtes",
      "zoningDistrict": "Sélectionnez le district de zonage",
      "affordabilityLevel": "Sélectionnez un niveau d'accessibilité",
      "allThatApply": "Sélectionnez toutes les réponses qui s'appliquent.",
      "springGardenS": "Le projet est-il situé au sud de Spring Garden Street ?",
      "yes": "Oui",
      "no": "Non",
      "affordability": {
        "lowIncome": "Faible revenu",
        "moderateIncome": "Revenu modéré",
      },
      "lotAreaSqft": "Entrez la superficie du lot en pieds carrés",
      "buildingHeight": "Entrez la hauteur du bâtiment",
      "totalUnits": "Nombre d'unités proposé dans le projet:",
      "unitsEarnedLow": "Unités supplémentaires gagnées (faible revenu) :",
      "unitsEarnedMod": "Unités supplémentaires gagnées (revenu modéré) :",
      "greenRoofBonus": "Nombre d'unités bonus pour toit vert :",
      "modIncomePayment": "Paiement estimatif du revenu modéré :",
      "lowIncomePayment": "Paiement estimé pour les personnes à faible revenu :",
      "requiredAffordableUnits": "Unités abordables requises par le MIHB :",
      "requiredMinAffordableUnits": "Nombre minimum d'unités abordables requises :",
      "totalRequiredAffordabilityUnits": "Nombre total d'unités abordables requises :",
      "additionalFar": "FAR supplémentaires gagnés :",
      "totalFar": "FAR total :",
      "totalFloor": "Surface de plancher totale autorisée :",
      "overlay": {
        "fithDistrict": "Ce projet se situe dans le Fifth District Overlay District (/VDO).",
        "greenRoof": "Ce projet permettra de gagner un bonus pour le toit vert.",
        "minMixed": "Ce projet s'inscrit dans le cadre de la superposition /MIN Mixed Income Neighborhoods. ",
        "todDevelopement": "Ce projet fait partie de la couche de développement orientée /TOD Transit.",
      },
      "sFHA": [
        "Zone à risque d'inondations spécial",
      ],
      "numberOfDwellingUnits": "Nombre de logements autorisés en vertu du zonage de base :",
      "about": "À propos",
      "aboutTitle": "À propos de la prime au logement à revenus mixtes",
      "aboutSubTitle": "Comment utiliser le calculateur",
      "paragraphOne": "La prime au logement à revenu mixte est destinée aux promoteurs qui ajoutent des logements abordables à leurs projets ou contribuent à un fonds qui soutient le logement abordable. En retour, le développement obtient une surface au sol, une hauteur et/ou des unités d'habitation « de plein droit ». Les développeurs peuvent choisir entre deux niveaux bonus. Le niveau de revenu modéré est une prime moindre, mais les normes d'accessibilité sont moins strictes ou le montant des paiements est inférieur. Le faible niveau de revenu est un avantage plus important, mais il est soumis à des normes d'accessibilité plus strictes ou à un montant de paiement plus élevé.",
      "paragraphTwo": {
        "text": "Le calculateur de primes au logement à revenus mixtes est utilisé pour estimer avec précision :",
        "bullets": [
          "Nombre total d'unités autorisées.",
          "Nombre total d'unités abordables que vous devrez fournir.",
          "Montant des frais compensatoires à payer pour un développement utilisant la prime au logement à revenus mixtes.",
        ],
      },
      "paragraphThree": {
        "text": "Pour commencer, sélectionnez le district de zonage de base de la propriété et entrez la superficie du lot. Vous devez également sélectionner les districts de superposition applicables. Vous pouvez utiliser",
        "link": {
          "text": "Atlas",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "pour trouver ces informations.",
      },
      "finalConfirmation": "Ce calculateur doit être utilisé pour la planification conceptuelle du projet. En cas de divergence entre le calculateur et le code de zonage de Philadelphie, le code de zonage de Philadelphie prévaut. La confirmation finale des unités, du nombre requis d'unités abordables et/ou du montant des frais compensatoires sera faite par le personnel de la Philadelphia City Planning Commission lors de l'examen du permis de zonage. ",
      "resources": "Ressources",
      "code1": {
        "link": {
          "text": "Code de Philadelphie — 14-702 (7) — Prime au logement à revenu mixte",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Code de Philadelphie — 14-533 — District de superposition de quartiers à revenus mixtes",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Fiches d'information sur les primes au logement à revenus mixtes",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};